"use client";

import { type HTMLMotionProps, motion } from "motion/react";

import { Slot, type WithAsChild } from "@/components/animate-ui/primitives/animate/slot";

type ButtonProps = WithAsChild<
	HTMLMotionProps<"button"> & {
		hoverScale?: number;
		tapScale?: number;
	}
>;

function Button({ hoverScale = 1.02, tapScale = 0.98, asChild = false, ...props }: ButtonProps) {
	const Component = asChild ? Slot : motion.button;

	return <Component whileTap={{ scale: tapScale }} whileHover={{ scale: hoverScale }} {...props} />;
}

export { Button, type ButtonProps };
